export default __webpack_public_path__ + "static/media/GinikaEzea.1ea16541.svg";